<form>
  <div class="modal-header">
    <h4 class="modal-title">{{ pageTitle }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row" *ngIf="rrItemsWithoutLotData.length > 0">
      <div class="col-md-12">
        <p>Receiving Report items without a lot:</p>
        <p
          ><b class="text-warning">{{ rrItemsWithoutLotData }}</b></p
        >
      </div>
    </div>
    <br *ngIf="rrItemsWithoutLotData.length > 0 && rrItems.length > 0" />
    <div class="row">
      <div class="col-md-6" *ngFor="let item of rrItems; let i = index">
        <div class="form-group">
          <label for="{{ item?.purchase_order_rfq?.product_name }}">
            {{ item?.purchase_order_rfq?.product_name }}
          </label>
          <input
            name="{{ item?.purchase_order_rfq?.product_name }}"
            type="number"
            class="form-control"
            [(ngModel)]="item.quantity"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="activeModal.dismiss('')"
      [translate]="'BUTTONS.CLOSE'"
    >
      <i class="fas fa-times"></i> Close
    </button>
    <button
      [disabled]="rrItems.length === 0"
      (click)="export(fileType.CSV)"
      type="button"
      class="btn btn-primary"
    >
      <i class="fas fa-file-excel"></i> Export to CSV
    </button>
    <button
      [disabled]="rrItems.length === 0"
      (click)="export(fileType.PDF)"
      type="button"
      class="btn btn-primary"
    >
      <i class="fas fa-file-pdf"></i> Print Labels
    </button>
  </div>
</form>
